class UnionFind {
  private parent = new Map<string, string>()

  constructor(ids: string[]) {
    for (const id of ids) {
      this.parent.set(id, id)
    }
  }

  /** Find with path compression */
  find(id: string): string {
    if (this.parent.get(id) !== id) {
      this.parent.set(id, this.find(this.parent.get(id)!))
    }
    return this.parent.get(id)!
  }

  /** Union two elements */
  union(id1: string, id2: string): void {
    const root1 = this.find(id1)
    const root2 = this.find(id2)

    if (root1 !== root2) {
      this.parent.set(root1, root2)
    }
  }
}

export default UnionFind